<template>
  <div>
    <h3>{{ question }}
      <b-badge v-if="tooltip" id="question_badge">?</b-badge>
    </h3>
    <b-tooltip v-if="tooltip" target="question_badge" triggers="hover">
      {{ tooltip }}
    </b-tooltip>
    <div>Wybierz jedną odpowiedź</div>
    <div v-for="(valueGroup, i) in values" :key="i">
      <template v-for="v in valueGroup">
        <b-button :id="v.value" @click="vote(v.value)" :variant="getVariant(v.value)" :key="'b'+v.value">
          {{ v.label }}
        </b-button>
        <b-tooltip v-if="v.tooltip" :target="v.value" triggers="hover" :delay="{show: 1000, hide: 0}"
                   :key="'t'+v.value">
          {{ v.tooltip }}
        </b-tooltip>
      </template>
    </div>

    <div>
      <b-button id="dkno_button" @click="dontKnow()" :variant="voteGroup.status==='DKNO' ? 'primary' : 'secondary'">
        nie wiem
      </b-button>
      <b-button id="cant_button" @click="cant()" :variant="voteGroup.status==='CANT' ? 'primary' : 'secondary'">
        nie widać
      </b-button>

      <b-tooltip target="dkno_button" triggers="hover" :delay="{show: 2000, hide: 0}">
        Należy wybrać tylko w sytuacji, gdy osoba oznaczająca zdjęcie mimo wszelkiej swojej wiedzy nie jest w stanie
        przyporządkować butów do żadnej z pozostałych kategorii mimo, że zdjęcia są czytelne. Oznaczenie tej opcji
        należy traktować jako ostateczność.
      </b-tooltip>

      <b-tooltip target="cant_button" triggers="hover" :delay="{show: 2000, hide: 0}">
        Należy wybrać tą opcję w sytuacji, gdy jakość zdjęć lub ułożenie butów nie pozwala na jednoznaczne przypisanie
        butów do żadnej z wymienionych kategorii.
      </b-tooltip>
    </div>
  </div>
</template>

<script>


import Tab from "@/components/Tab";

export default {
  extends: Tab,
  name: 'tabSingle',
  props: ["voteGroup", "values", "question", "tooltip"],
  data: function () {
    return {}
  },
  methods: {
    vote(value) {
      let key = Object.keys(this.voteGroup.values)[0];
      this.voteGroup.values[key] = value;
      this.done()
    },
    getVariant(value) {
      let key = Object.keys(this.voteGroup.values)[0];
      return this.voteGroup.values[key] === value ? "primary" : "secondary"
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button {
  margin: 1em
}
</style>
